import React, {Component} from 'react';
import styled from 'styled-components';
import {SharedMapContextConsumer} from "../contexts/SharedMapContext";
import Localizer from "../helpers/Localizer";

const Wrapper = styled.div`
    position: absolute;
    right: 7px;
    background: #fff;
    z-index: 100;
    bottom: 61px;
    box-shadow: 0 0 3px 0 rgba(0,0,0,.5);
    .menu-icon { display: none; }
    ul {
        list-style: none;
        padding: 10px;
        padding-bottom: 0;
        text-align: left;
      li {
            font-family: "Istok Web",sans-serif!important;
            color: #606060!important;
            text-decoration: none!important;
            cursor: pointer!important;
            i {
                color: #e02d5f;
            }
      }
    }
    
    @media (max-width: 991px) {
        bottom: 10px;
        i { display: none; }
        .menu-label { display: none; }
        .menu-icon { display: inline-block; }
    }
    
    @media (max-width: 415px) {
        ul {
            li {
                float: left;
                margin-right: 8px;
                margin-bottom: 4px;
                
                i.fa {
                    display: none;
                }
                &:last-child{
                    margin-right: 0;
                }
            }
            
        }
    }
`;

class Menu extends Component {
    render() {

        const locale = document.getElementsByTagName('html')[0].getAttribute('lang');
        let appUrl = document.getElementsByTagName('body')[0].getAttribute('data-ibiza-website-url');

        return (
            <SharedMapContextConsumer>
                {({toggleVisibility, visibility}) => (
                    <Wrapper>
                        <ul>
                            <li onClick={() => {
                                toggleVisibility('house')
                            }}>
                                <i className={visibility.house ? "fa fa-check-square" : "fa fa-square"}/> <span
                                className="menu-label">{Localizer.translate("villas", locale)}</span><span
                                className="menu-icon"><img alt="villa"
                                                           src={visibility.house
                                                               ? appUrl + "/assets/frontend/images/elements/icon-house.svg"
                                                               : appUrl + "/assets/frontend/images/elements/icon-house-grey.svg"}/></span>
                            </li>
                            <li onClick={() => {
                                toggleVisibility('restaurant')
                            }}>
                                <i className={visibility.restaurant ? "fa fa-check-square" : "fa fa-square"}/> <span
                                className="menu-label">{Localizer.translate("restaurants", locale)}</span><span
                                className="menu-icon"><img alt="restaurant"
                                                           src={visibility.restaurant
                                                               ? appUrl + "/assets/frontend/images/elements/icon-restaurant.svg"
                                                               : appUrl + "/assets/frontend/images/elements/icon-restaurant-grey.svg"}/></span>
                            </li>
                            <li onClick={() => {
                                toggleVisibility('club')
                            }}>
                                <i className={visibility.club ? "fa fa-check-square" : "fa fa-square"}/> <span
                                className="menu-label">{Localizer.translate("clubs", locale)}</span><span
                                className="menu-icon"><img alt="club"
                                                           src={visibility.club
                                                               ? appUrl + "/assets/frontend/images/elements/icon-club.svg"
                                                               : appUrl + "/assets/frontend/images/elements/icon-club-grey.svg"}/></span>
                            </li>
                            <li onClick={() => {
                                toggleVisibility('beach')
                            }}>
                                <i className={visibility.beach ? "fa fa-check-square" : "fa fa-square"}/> <span
                                className="menu-label">{Localizer.translate("beaches", locale)}</span><span
                                className="menu-icon"><img alt="beach"
                                                           src={visibility.beach
                                                               ? appUrl + "/assets/frontend/images/elements/icon-beach.svg"
                                                               : appUrl + "/assets/frontend/images/elements/icon-beach-grey.svg"}/></span>
                            </li>
                            <li onClick={() => {
                                toggleVisibility('place')
                            }}>
                                <i className={visibility.place ? "fa fa-check-square" : "fa fa-square"}/> <span
                                className="menu-label">{Localizer.translate("places", locale)}</span><span
                                className="menu-icon"><img alt="place"
                                                           src={visibility.place
                                                               ? appUrl + "/assets/frontend/images/elements/icon-place.svg"
                                                               : appUrl + "/assets/frontend/images/elements/icon-place-grey.svg"}/></span>
                            </li>
                            <li onClick={() => {
                                toggleVisibility('beach_club')
                            }}>
                                <i className={visibility.beach_club ? "fa fa-check-square" : "fa fa-square"}/> <span
                                className="menu-label">{Localizer.translate("beach clubs", locale)}</span><span
                                className="menu-icon"><img alt="beach club"
                                                           src={visibility.beach_club
                                                               ? appUrl + "/assets/frontend/images/elements/icon-beach_club.svg"
                                                               : appUrl + "/assets/frontend/images/elements/icon-beach_club-grey.svg"}/></span>
                            </li>
                            <li onClick={() => {
                                toggleVisibility('store')
                            }}>
                                <i className={visibility.store ? "fa fa-check-square" : "fa fa-square"}/> <span
                                className="menu-label">{Localizer.translate("supermarkets", locale)}</span><span
                                className="menu-icon"><img alt="supermarket"
                                                           src={visibility.store
                                                               ? appUrl + "/assets/frontend/images/elements/icon-store.svg"
                                                               : appUrl + "/assets/frontend/images/elements/icon-store-grey.svg"}/></span>
                            </li>
                            <li onClick={() => {
                                toggleVisibility('market')
                            }}>
                                <i className={visibility.market ? "fa fa-check-square" : "fa fa-square"}/> <span
                                className="menu-label">{Localizer.translate("markets", locale)}</span><span
                                className="menu-icon"><img alt="market"
                                                           src={visibility.market
                                                               ? appUrl + "/assets/frontend/images/elements/icon-market.svg"
                                                               : appUrl + "/assets/frontend/images/elements/icon-market-grey.svg"}/></span>
                            </li>
                        </ul>
                    </Wrapper>
                )}
            </SharedMapContextConsumer>
        );
    };
}

export default Menu;
